var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManageMyWealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8766_290401)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1863 5.45441C13.2268 5.45441 10.8577 7.82337 10.8577 10.7823C10.8577 13.7427 13.227 16.1116 16.1863 16.1116C19.1457 16.1116 21.5149 13.7427 21.5149 10.7823C21.5149 7.82337 19.1458 5.45441 16.1863 5.45441ZM16.1863 3.8457C12.3386 3.8457 9.24902 6.93472 9.24902 10.7823C9.24902 14.6311 12.3384 17.7203 16.1863 17.7203C20.0342 17.7203 23.1236 14.6311 23.1236 10.7823C23.1236 6.93472 20.0341 3.8457 16.1863 3.8457Z",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9438 20.3714C10.0982 20.3714 7.79133 22.6783 7.79133 25.5239V25.6283C7.79133 26.5168 8.51157 27.237 9.40004 27.237H22.5943C23.4828 27.237 24.203 26.5168 24.203 25.6283V25.5239C24.203 22.6783 21.8962 20.3714 19.0505 20.3714H12.9438ZM12.9438 18.7627C9.20972 18.7627 6.18262 21.7898 6.18262 25.5239V25.6283C6.18262 27.4053 7.6231 28.8457 9.40004 28.8457H22.5943C24.3713 28.8457 25.8117 27.4053 25.8117 25.6283V25.5239C25.8117 21.7898 22.7846 18.7627 19.0505 18.7627H12.9438Z",
    fill: "#1A1B1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8766_290401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageMyWealth);
export default __webpack_public_path__ + "static/media/manage-my-wealth.00b3295862cbcd9746b48d079b090baf.svg";
export { ForwardRef as ReactComponent };